'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  background-color: transparent;\n'], ['\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  background-color: transparent;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 7px 14px;\n  min-width: 85%;\n  height: 35px;\n  background-color: ', ';\n  border: 1px solid ', ';\n  font-weight: 500;\n  font-size: 12px;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 7px 14px;\n  min-width: 85%;\n  height: 35px;\n  background-color: ', ';\n  border: 1px solid ', ';\n  font-weight: 500;\n  font-size: 12px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 0 1 100%;\n'], ['\n  flex: 0 1 100%;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 0 0 auto;\n'], ['\n  flex: 0 0 auto;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: static;\n  flex: 0 0 12px;\n  margin-left: 20px;\n'], ['\n  position: static;\n  flex: 0 0 12px;\n  margin-left: 20px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UICloseButton = require('UIComponents/button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'ChatAreaAlert__Wrapper'
})(_templateObject);

var Alert = _styledComponents2.default.div.withConfig({
  displayName: 'ChatAreaAlert__Alert'
})(_templateObject2, _colors.MARIGOLD_LIGHT, _colors.MARIGOLD_MEDIUM);

var Title = _styledComponents2.default.div.withConfig({
  displayName: 'ChatAreaAlert__Title'
})(_templateObject3);

var LinkWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'ChatAreaAlert__LinkWrapper'
})(_templateObject4);

var StyledCloseButton = (0, _styledComponents2.default)(_UICloseButton2.default).withConfig({
  displayName: 'ChatAreaAlert__StyledCloseButton'
})(_templateObject5);

var ChatAreaAlert = function (_React$Component) {
  _inherits(ChatAreaAlert, _React$Component);

  function ChatAreaAlert() {
    _classCallCheck(this, ChatAreaAlert);

    return _possibleConstructorReturn(this, (ChatAreaAlert.__proto__ || Object.getPrototypeOf(ChatAreaAlert)).apply(this, arguments));
  }

  _createClass(ChatAreaAlert, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          Alert,
          null,
          _react2.default.createElement(
            Title,
            null,
            this.props.title
          ),
          _react2.default.createElement(
            LinkWrapper,
            null,
            this.props.link
          ),
          _react2.default.createElement(StyledCloseButton, { color: _colors.OBSIDIAN, onClick: this.props.onClose })
        )
      );
    }
  }]);

  return ChatAreaAlert;
}(_react2.default.Component);

ChatAreaAlert.propTypes = {
  link: _react.PropTypes.node,
  onClose: _react.PropTypes.func.isRequired,
  title: _react.PropTypes.node.isRequired
};

ChatAreaAlert.defaultProps = {
  onClose: function onClose() {}
};

exports.default = ChatAreaAlert;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/ChatAreaAlert.js
// module id = 1172
// module chunks = 2 3